import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

import { ExecutiveSummaryPluginService } from './executivesummary-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';

@Component({
    selector: 'executivesummary-edit',
    templateUrl: './executivesummary-edit.component.html',
    standalone: false
})
export class ExecutiveSummaryEditPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  editForm: UntypedFormGroup;
  public processing = false;
  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private service: ExecutiveSummaryPluginService,
    location: Location,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save(model: any) {
    this.processing = true;
    this.service.updateExecutiveSummary(this.inspectionId, this.pluginId, model.value).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initForm() {
    this.editForm = new UntypedFormGroup({
      value: new UntypedFormControl(this.plugin.config.Value)
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      -1,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  selectTypesMenu(e: any) {}

  onTypesMenuClose() {}

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }
}
